import styled from 'styled-components';

import variables from '../../../styles/variables';
import PCOtag from '../../../images/pts.svg';

interface Props {
  readonly customStyles?: string;
  readonly isComparisonPage?: boolean;
}

export const PromoContainer = styled.div<Props>`
  display: flex;
  flex-wrap: wrap;
  height: fit-content;
  align-self: center;
  ${(props) => (props.customStyles ? props.customStyles : null)};
  @media screen and (max-width: 1100px) {
    order: ${({ isComparisonPage }) => (isComparisonPage ? '1' : '2')};
    width: ${({ isComparisonPage }) => (isComparisonPage ? '100%' : 'auto')};
    margin-bottom: ${({ isComparisonPage }) => isComparisonPage ? '8px' : '0'};
  }
  @media screen and (max-width: 1024px) {
    position: relative;
    top: 0;
    left: 0;
    max-width: 95px;
    order: 1;
    margin-bottom: 0;
    width: 100%;
  }
`;

export const OptimumPromo = styled.p`
  color: ${variables.colorRed};
  font-size: 11px;
  position: relative;
  margin: 0;
  line-height: 1;
  span {
    display: block;
    position: relative;
  }
  br {
    &.mobileBreak {
      display: none;
      @media screen and (min-width: 768px) and (max-width: 1023px) {
        display: inline-block;
      }
    }
  }
`;

export const EarnTag = styled.div`
  color: ${variables.colorRed};
  width: 100%;
`;

export const PromoNumber = styled.span<Props>`
  font-size: 18px;
  font-weight: bold;
  @media screen and (max-width: 375px) {
    font-size: ${({ isComparisonPage }) => isComparisonPage ? '14px' : '18px'};
  }
  @media screen and (max-width: 320px) {
    font-size: ${({ isComparisonPage }) => isComparisonPage ? '12px' : '18px'};
  }
  &:after {
    position: absolute;
    right: -1.1em;
    width: 1em;
    height: 1em;
    content: '';
    background-image: url(${PCOtag});
    background-size: 1em;
    background-repeat: no-repeat;
  }
`;
